import React, { useCallback, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { Form } from '@unform/web';

import { mutate as mutateGlobal } from 'swr';
import api from '../../services/api';
import { useFetch } from '../../hooks/useFetch';
import { useToast } from '../../hooks/toast';

import ButtonPrimaryGree from '../../components/ButtonPrimaryGreen';
import { InputSearch } from '../../components/Form';
import NavbarMenu from '../../components/NavbarMenu';
import ContainerBox from '../../components/ContainerBox';
import ButtonGroupbox from '../../components/ContainerBox/ButtonGroupbox';
import Table from '../../components/Table';
import Loading from '../../components/Loading';
import Pagination from '../../components/Pagination';

import { Container, TotalItems } from './styles';

const Units = () => {
  const formRef = useRef(null);

  const [page, setPage] = useState(1);
  const [url, setUrl] = useState('/units?page=1');
  const [showUnits, setShowUnits] = useState(true);

  const { dataList: units, loading, totalItems } = useFetch(
    `/units?page=${page}`
  );

  const { dataList: searchUnity, loading: loadingSearch } = useFetch(url);

  const { addToast } = useToast();

  const head = {
    id: 'ID',
    description: 'Descrição',
  };

  const handleBrandsDelete = useCallback(
    async (id) => {
      try {
        if (
          window.confirm(`Tem Certeza que realmente deseja excluir o registro?`)
        ) {
          await api.delete(`/units/${id}`);

          mutateGlobal(`/units?page=${page}`);
          mutateGlobal(url);

          addToast({
            type: 'success',
            title: 'Cadastro Excluido com Sucesso',
          });
        } else {
          return;
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao excluir verifique.',
        });
      }
    },
    [addToast, page, url]
  );

  const handleSubmit = useCallback(() => {
    const input = formRef.current.getFieldValue('inputunity');

    if (!input) {
      setUrl('/units?page=1');
      setPage(1);
      setShowUnits(true);

      return;
    }

    setUrl(`/unitysearch?search=${input}`);
    setShowUnits(false);
    formRef.current.reset();
  }, []);

  const handleEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSubmit();
      }
    },
    [handleSubmit]
  );

  return (
    <Container>
      <NavbarMenu />
      <ContainerBox title="Unidades">
        <ButtonGroupbox>
          <Link to="/units/newedit">
            <ButtonPrimaryGree icon={FiPlus}>Adicionar</ButtonPrimaryGree>
          </Link>

          <Form ref={formRef} onSubmit={() => {}}>
            <InputSearch
              id="inputunity"
              name="inputunity"
              autoComplete="off"
              onKeyDown={(e) => handleEnter(e)}
              handleClick={handleSubmit}
            />
          </Form>
        </ButtonGroupbox>

        {showUnits && loading && <Loading />}

        {showUnits && !loading && units && (
          <>
            <Table
              head={head}
              data={units}
              handleDelete={handleBrandsDelete}
              pathname="/units/newedit"
            />
            {totalItems && (
              <TotalItems>
                <span>
                  Total de registro(s): <b>{totalItems}</b>
                </span>
              </TotalItems>
            )}
            {totalItems > 20 && (
              <Pagination
                setPage={setPage}
                currentPage={page}
                totalItems={totalItems}
              />
            )}
          </>
        )}

        {!showUnits && loadingSearch && <Loading />}

        {!showUnits && !loadingSearch && searchUnity && (
          <Table
            head={head}
            data={searchUnity}
            handleDelete={handleBrandsDelete}
            pathname="/units/newedit"
          />
        )}
      </ContainerBox>
    </Container>
  );
};

export default Units;
